export { alertError, alertInfo, alertSuccess } from '@waypoint/react/notifications';

import { z } from 'zod';

import { ApolloError } from '@apollo/client';

const PUBLIC_ERROR_SCHEMA = z
  .object({
    message: z.literal('PublicGraphqlError'),
    extensions: z.object({
      code: z.enum(['VALIDATION_ERROR', 'MODEL_NOT_FOUND']),
      message: z.string(),
    }),
  })
  .transform((data) => data.extensions);

export function getApolloErrorMessage(error: unknown): null | string {
  if (!(error instanceof ApolloError)) {
    return null;
  }
  const parseResponse = PUBLIC_ERROR_SCHEMA.safeParse(error.graphQLErrors[0]);
  if (!parseResponse.success) {
    return null;
  }
  return parseResponse.data.message;
}
